import { useSSRContext } from 'vue'
import type { SSRContext } from '@/types/ssr/SSRContext'

export const useSafeSSRContext = (): SSRContext => {
  if (!import.meta.env.SSR) {
    throw new Error('Cannot access SSR context outside of SSR')
  }

  const context = useSSRContext()

  if (!context) {
    throw new Error('SSR Context is not set')
  }

  return context as SSRContext
}